export enum QueryStatusEnum {
  AUTO_APPROVED = "AUTO_APPROVED",
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REPROVED = "REPROVED",
}

export enum QueryConnectionsEnum {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
  PAUSED = "PAUSED",
}
